import { Translate } from '@chipinside/translate'
import { Tooltip } from '@mui/material'
import { CSSProperties, styled } from '@mui/material/styles'

import { HeatStress } from '#/@types/backend'
import { Icon as AppIcon } from '#/components/Icon'
import Colors from '#/styles/Colors'

const Content = styled('div')(({ alignItems, flexDirection }: CSSProperties) => ({
  alignItems,
  display: 'flex',
  flexDirection,
  gap: flexDirection === 'row' ? 10 : 0,
}))

const Label = styled('p')(({ status }: { status: HeatStress }) => ({
  color: Colors.dtr[status],
  fontWeight: 500,
  lineHeight: '16px',
  margin: 'auto 0',
}))

const Icon = styled(AppIcon)(({ status }: { status: HeatStress }) => ({
  color: Colors.dtr[status],
  fontSize: 25,
  height: '30px',
}))

type Props = {
  value?: {
    status?: HeatStress
    text: string
  }
  with_label?: boolean
  alignItems?: CSSProperties['alignItems']
  flexDirection?: CSSProperties['flexDirection']
}

const TypeDTR = ({
  alignItems = 'start',
  flexDirection = 'row',
  value,
  with_label = true,
}: Props) => {
  const { status, text } = value ?? {}

  if (!status) {
    return <span>-</span>
  }

  return (
    <Tooltip title={`${Translate({ messageKey: 'DTR_initials' })} - ${text}`}>
      <Content alignItems={alignItems} flexDirection={flexDirection}>
        <Icon size="large" name="dtr" status={status} />
        {with_label && <Label status={status}>{text}</Label>}
      </Content>
    </Tooltip>
  )
}

export default TypeDTR
